module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('a', {
    attrs: {
      "id": "pageiv"
    }
  }), _vm._v("Copyright © 2001 by Mark Bowden")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover design by Michael Patrick Dudding")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover photographs: front, (public domain)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Colombia National Registry; back, Colombian police and military forces storm the rooftop where drug lord Pablo Escobar was shot dead, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© AFP/Stringer/Getty")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("PHOTO CREDITS—Insert "), _c('a', {
    attrs: {
      "href": "#/OEBPS/pro.htm#page1"
    }
  }, [_vm._v("page 1")]), _vm._v(": Pablo as he appeared in 1983 (Reuters NewMedia Inc./CORBIS). Insert "), _c('a', {
    attrs: {
      "href": "#/OEBPS/pro.htm#page2"
    }
  }, [_vm._v("page 2")]), _vm._v(": Map of Colombia ("), _c('em', [_vm._v("The Philadelphia Inquirer")]), _vm._v("); Map of Medellín ("), _c('em', [_vm._v("The Philadelphia Inquirer")]), _vm._v("). Insert "), _c('a', {
    attrs: {
      "href": "#/OEBPS/pro.htm#page3"
    }
  }, [_vm._v("page 3")]), _vm._v(": Pablo and his wife Maria Victoria in 1983 (Reuters NewMedia Inc./CORBIS); Pablo embraces his wife, Maria Victoria; and his daughter Manuela (RCN). Insert "), _c('a', {
    attrs: {
      "href": "#/OEBPS/p01.htm#page4"
    }
  }, [_vm._v("page 4")]), _vm._v(": President Bush with Colombian president Virgilio Barco (AP/World Wide Photos); Morris D. Busby ("), _c('em', [_vm._v("The Philadelphia Inquirer")]), _vm._v("); Luis Galán (AP/World Wide Photos); Colombian president César Gaviria ("), _c('em', [_vm._v("The Philadelphia Inquirer")]), _vm._v("). Insert "), _c('a', {
    attrs: {
      "href": "#/OEBPS/p01.htm#page5"
    }
  }, [_vm._v("page 5")]), _vm._v(": A dinner party in the mid-1980s (Mark Bowden); Fernando Galeano (AP/ World Wide Photos); A view from the comfortable living room of Pablo’s suite at "), _c('em', [_vm._v("La Catedral")]), _vm._v(" prison (Mark Bowden); DEA agents Steve Murphy and Javier Peña (Mark Bowden). Insert "), _c('a', {
    attrs: {
      "href": "#/OEBPS/p01_c01.htm#page6"
    }
  }, [_vm._v("page 6")]), _vm._v(": Agent Joe Toft (Tim Dunn, freelance photographer); José Rodríguez Gacha ("), _c('em', [_vm._v("El Espectador")]), _vm._v("); Colonel Hugo Martinez ("), _c('em', [_vm._v("The Philadelphia Inquirer")]), _vm._v("); Eduardo Mendoza (AP/World Wide Photos). Insert "), _c('a', {
    attrs: {
      "href": "#/OEBPS/p01_c01.htm#page7"
    }
  }, [_vm._v("page 7")]), _vm._v(": An exhibit at the "), _c('em', [_vm._v("Policía Nacional de Colombia")]), _vm._v("’s museum ("), _c('em', [_vm._v("The Philadelphia Inquirer")]), _vm._v("); the third page of a handwritten letter (Mark Bowden); the Colombian government and U.S. embassy printed thousands of posters and handbills (RCN); a victim of "), _c('em', [_vm._v("Los Pepes")]), _vm._v(" (RCN). Insert "), _c('a', {
    attrs: {
      "href": "#/OEBPS/p01_c01.htm#page8"
    }
  }, [_vm._v("page 8")]), _vm._v(": Members of Colonel Martinez’s Search Bloc (Mark Bowden); Pablo’s grave in Medellín ("), _c('em', [_vm._v("The Philadelphia Inquirer")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove Atlantic, 154 West 14th Street, New York, NY 10011 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_vm._v("permissions@groveatlantic.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("Published simultaneously in Canada"), _c('br'), _vm._v("\nPrinted in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First Grove Atlantic hardcover edition: May 2001"), _c('br'), _vm._v("\nThis Grove Atlantic paperback edition: February 2018")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Library of Congress Cataloging-in-Publication data available for this title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN 978-0-8021-2773-0"), _c('br'), _vm._v("\neISBN 978-0-8021-9757-3")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Text designed by Norman Tuttle"), _c('br'), _vm._v("\nThis book was set in Dante MT with ITC New Baskerville")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("\nan imprint of Grove Atlantic"), _c('br'), _vm._v("\n154 West 14th Street New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    attrs: {
      "href": "http://groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("groveatlantic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("18 19 20 21 10 9 8 7 6 5 4 3 2 1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d473dc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 69
// module chunks = 0